/* ============================================================
   miori · Widerruf-Formular (Stufe 2 / Übermittlung)
   --------------------------------------------------------------
   Gesetzlich vorgeschriebener EU-Widerrufsbutton (§ 356a BGB).
   Progressive Enhancement: fängt den Form-Submit ab und sendet
   per fetch() JSON an den Cloudflare-Worker. Kein Page-Reload.

   API-Vertrag (Worker):
     POST {worker_endpoint}  (Content-Type: application/json)
       { name, order_reference, email, reason?, turnstile_token }
     200 { ok:true,  vorgang_id, received_at }
     400 { ok:false, error:'validation', fields:{ <feld>:<grund> } }
     403 { ok:false, error:'turnstile' }
     403 { ok:false, error:'forbidden' }
     429 { ok:false, error:'rate_limited' }
     500 { ok:false, error:'server' }
   ============================================================ */
(function () {
  "use strict";

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* Mapping API-Feldnamen → DOM-Feldnamen */
  var FIELD_MAP = {
    name: "name",
    order_reference: "order_reference",
    email: "email",
    reason: "reason",
  };

  function initForm(root) {
    if (!root || root.dataset.mwInit === "1") return;
    root.dataset.mwInit = "1";

    var form = root.querySelector("[data-mw-form]");
    if (!form) return;

    var endpoint = (root.dataset.workerEndpoint || "").trim();
    var submitBtn = form.querySelector("[data-mw-submit]");
    var generalError = root.querySelector("[data-mw-general-error]");
    var successBox = root.querySelector("[data-mw-success]");
    var successTitle = root.querySelector("[data-mw-success-title]");
    var vorgangSlot = root.querySelector("[data-mw-vorgang]");

    /* Texte aus data-Attributen (mit Fallback) */
    var TXT = {
      required: root.dataset.msgRequired || "Bitte füllen Sie dieses Pflichtfeld aus.",
      email: root.dataset.msgEmail || "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      turnstile: root.dataset.msgTurnstile || "Der Spam-Schutz konnte nicht bestätigt werden. Bitte versuchen Sie es erneut.",
      rateLimited: root.dataset.msgRateLimited || "Es wurden zu viele Anfragen gesendet. Bitte versuchen Sie es in einigen Minuten erneut.",
      server: root.dataset.msgServer || "Es ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
      network: root.dataset.msgNetwork || "Die Verbindung ist fehlgeschlagen. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
      missingEndpoint: root.dataset.msgConfig || "Das Formular ist noch nicht vollständig konfiguriert. Bitte kontaktieren Sie uns direkt.",
    };

    /* ── Hilfsfunktionen für Feld-Fehler ── */
    function fieldWrap(apiField) {
      var domName = FIELD_MAP[apiField] || apiField;
      return form.querySelector('[data-mw-field="' + domName + '"]');
    }

    function setFieldError(apiField, message) {
      var wrap = fieldWrap(apiField);
      if (!wrap) return;
      var input = wrap.querySelector("input, textarea");
      var errEl = wrap.querySelector("[data-mw-error]");
      if (input) {
        input.setAttribute("aria-invalid", "true");
      }
      if (errEl) {
        errEl.textContent = message || TXT.required;
      }
    }

    function clearFieldError(wrap) {
      var input = wrap.querySelector("input, textarea");
      var errEl = wrap.querySelector("[data-mw-error]");
      if (input) input.removeAttribute("aria-invalid");
      if (errEl) errEl.textContent = "";
    }

    function clearAllErrors() {
      var wraps = form.querySelectorAll("[data-mw-field]");
      for (var i = 0; i < wraps.length; i++) clearFieldError(wraps[i]);
      if (generalError) {
        generalError.textContent = "";
        generalError.hidden = true;
      }
    }

    function showGeneralError(message) {
      if (!generalError) return;
      generalError.textContent = message;
      generalError.hidden = false;
      try {
        generalError.focus();
      } catch (e) {
        /* nicht fokussierbar – ignorieren */
      }
    }

    /* ── Turnstile-Token lesen ── */
    function getTurnstileToken() {
      /* 1. Bevorzugt das offizielle API */
      if (window.turnstile && typeof window.turnstile.getResponse === "function") {
        try {
          var t = window.turnstile.getResponse();
          if (t) return t;
        } catch (e) {
          /* fällt durch auf das versteckte Feld */
        }
      }
      /* 2. Fallback: verstecktes cf-turnstile-response-Feld */
      var hidden = form.querySelector('[name="cf-turnstile-response"]');
      return hidden ? hidden.value : "";
    }

    function resetTurnstile() {
      if (window.turnstile && typeof window.turnstile.reset === "function") {
        try {
          window.turnstile.reset();
        } catch (e) {
          /* ignorieren */
        }
      }
    }

    /* ── Client-Validierung (3 Pflichtfelder + E-Mail-Format) ── */
    function validate(values) {
      var ok = true;
      if (!values.name) {
        setFieldError("name", TXT.required);
        ok = false;
      }
      if (!values.order_reference) {
        setFieldError("order_reference", TXT.required);
        ok = false;
      }
      if (!values.email) {
        setFieldError("email", TXT.required);
        ok = false;
      } else if (!EMAIL_RE.test(values.email)) {
        setFieldError("email", TXT.email);
        ok = false;
      }
      return ok;
    }

    function setBusy(busy) {
      if (!submitBtn) return;
      submitBtn.disabled = busy;
      submitBtn.setAttribute("aria-busy", busy ? "true" : "false");
    }

    function readValue(domName) {
      var el = form.elements[domName];
      return el && typeof el.value === "string" ? el.value.trim() : "";
    }

    /* ── Submit-Handler ── */
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      clearAllErrors();

      if (!endpoint) {
        showGeneralError(TXT.missingEndpoint);
        return;
      }

      var values = {
        name: readValue("name"),
        order_reference: readValue("order_reference"),
        email: readValue("email"),
        reason: readValue("reason"),
      };

      if (!validate(values)) {
        var firstInvalid = form.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      var token = getTurnstileToken();

      var payload = {
        name: values.name,
        order_reference: values.order_reference,
        email: values.email,
        turnstile_token: token,
      };
      /* reason nur mitsenden, wenn ausgefüllt (Datensparsamkeit) */
      if (values.reason) {
        payload.reason = values.reason;
      }

      setBusy(true);

      /* Nur echte Netzwerk-/fetch-Fehler dürfen die network-Meldung auslösen.
         Die Antwort-/Erfolgsbehandlung läuft daher in einem eigenen try/catch
         und wird NICHT vom äußeren .catch erfasst – sonst würde ein UI-/Render-
         Fehler NACH erfolgreicher Übermittlung fälschlich als „Verbindung
         fehlgeschlagen" angezeigt (Nutzer sendet sonst erneut). */
      fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then(
          function (response) {
            /* fetch erfolgreich (auch 4xx/5xx) → Body lesen, dann Antwort
               behandeln. Ab hier dürfen Fehler NICHT mehr als Netzwerkfehler
               gelten. */
            return response
              .json()
              .catch(function () {
                return {};
              })
              .then(function (data) {
                try {
                  handleResponse(response.status, data);
                } catch (e) {
                  /* Fehler in der Antwort-/Erfolgsbehandlung (z.B. UI-Render):
                     der Widerruf ist serverseitig u.U. längst eingegangen –
                     daher KEINE network-Meldung. Generischer technischer Hinweis,
                     Button wieder freigeben. */
                  setBusy(false);
                  showGeneralError(TXT.server);
                }
              });
          },
          function () {
            /* Echter Netzwerk-/fetch-Reject (offline, DNS, CORS, abgebrochen) */
            setBusy(false);
            resetTurnstile();
            showGeneralError(TXT.network);
          }
        );
    });

    /* ── Antwort-Behandlung gemäß API-Vertrag ── */
    function handleResponse(status, data) {
      data = data || {};

      if (status === 200 && data.ok) {
        showSuccess(data.vorgang_id);
        return;
      }

      setBusy(false);

      if (status === 400 && data.error === "validation" && data.fields) {
        var keys = Object.keys(data.fields);
        for (var i = 0; i < keys.length; i++) {
          setFieldError(keys[i], data.fields[keys[i]]);
        }
        var firstInvalid = form.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      if (status === 403 && data.error === "turnstile") {
        resetTurnstile();
        showGeneralError(TXT.turnstile);
        return;
      }

      if (status === 429) {
        resetTurnstile();
        showGeneralError(TXT.rateLimited);
        return;
      }

      /* 403 forbidden, 500 server, alle übrigen Fälle */
      resetTurnstile();
      showGeneralError(TXT.server);
    }

    /* ── Erfolg: Formular ausblenden, Erfolgsmeldung + Vorgangsnummer ── */
    function showSuccess(vorgangId) {
      if (form) form.hidden = true;
      if (generalError) {
        generalError.textContent = "";
        generalError.hidden = true;
      }
      if (vorgangSlot && vorgangId) {
        vorgangSlot.textContent = vorgangId;
      }
      if (successBox) {
        successBox.hidden = false;
        /* Fokus auf die Erfolgs-Überschrift (tabindex="-1") –
           einziger Ankündigungs-Mechanismus, daher keine aria-live-Region. */
        var focusTarget = successTitle || successBox;
        try {
          focusTarget.focus();
        } catch (e) {
          /* ignorieren */
        }
        successBox.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }

  function boot() {
    var roots = document.querySelectorAll("[data-mw-root]");
    for (var i = 0; i < roots.length; i++) initForm(roots[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
